export default __webpack_public_path__ + "static/media/jesper.f73064a5.png";